export default __webpack_public_path__ + "static/QA-relatorios-d-problemas-encontrados-5290d389637fc92ed4f2c54a72aea965.png";